import { FC } from 'react'
import type { IconProps } from '../../types'

const Prohibited: FC<IconProps> = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1Z'
      fill='#D00A00'
      stroke='white'
      strokeWidth='2'
    />
    <path
      d='M14.2416 7.99112C14.7298 7.50296 15.521 7.50296 16.0092 7.99112C16.4972 8.47928 16.4973 9.27057 16.0092 9.75869L13.768 11.9999L16.0092 14.2411C16.4972 14.7293 16.4973 15.5206 16.0092 16.0087C15.5211 16.4968 14.7298 16.4968 14.2416 16.0087L12.0004 13.7675L9.75918 16.0087C9.27106 16.4968 8.47977 16.4968 7.9916 16.0087C7.50345 15.5205 7.50345 14.7293 7.9916 14.2411L10.2328 11.9999L7.9916 9.75869C7.50345 9.27054 7.50345 8.47927 7.9916 7.99112C8.47976 7.50296 9.27103 7.50296 9.75918 7.99112L12.0004 10.2323L14.2416 7.99112Z'
      fill='white'
    />
  </svg>
)

export default Prohibited
